export const propertyStatusOptions = ["Owned", "Mortgaged", "Living with Relatives", "Company Provided", "Rented"];
